import React from "react";
import "./hero.css";

function Hero() {
  return (
    <section className="hero">
      {/* Left Side Image */}
      <div className="hero-left">
        <img src="/images/image1.jpg" alt="Wedding Outfit" />
      </div>

      {/* Right Side Content */}
      <div className="hero-left">
        <img src="/images/image2.jpg" alt="Wedding Outfit" />
      </div>
    </section>
  );
}

export default Hero;
